import { render, staticRenderFns } from "./AgreementsCustomer.vue?vue&type=template&id=0d3af421&"
import script from "./AgreementsCustomer.vue?vue&type=script&lang=js&"
export * from "./AgreementsCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports